import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { EguardCustomLoaderService } from './custom-loader.service';
import { LoaderState } from './custom-loader.model';
@Component({
    selector: 'eguard-custom-loader',
    templateUrl: 'custom-loader.component.html',
    styleUrls: ['custom-loader.component.scss']
})
export class EguardCustomLoaderComponent implements OnInit {

    show = false;

    private subscription: Subscription;
    constructor(
        private loaderService: EguardCustomLoaderService
    ) {}

    ngOnInit() {

        this.subscription = this.loaderService.loaderSubject
            .subscribe((state: LoaderState) => {
                this.show = state.show;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/custom-loader/custom-loader.component.ts